'use strict';

var dataLayer = window.dataLayer || [];

module.exports = {
    // when user book an appointment : bookingFormSubmitted event
    formStartHandle: function (formId, formName, formDestination) {
        var datalayerObject = {};
        datalayerObject.event = 'form_start';
        datalayerObject.form_id = formId;
        datalayerObject.form_name = formName;
        datalayerObject.form_destination = formDestination;
        dataLayer.push(datalayerObject);
    },

    formCloseHandle: function (formId, formName, formDestination, formSubmitText) {
        var datalayerObject = {};
        datalayerObject.event = 'form_closed';
        datalayerObject.form_id = formId;
        datalayerObject.form_name = formName;
        datalayerObject.form_destination = formDestination;
        datalayerObject.form_submit_text = formSubmitText;
        dataLayer.push(datalayerObject);
    },

    formSubmitHandle: function (formId, formName, formDestination, formSubmitText) {
        var datalayerObject = {};
        datalayerObject.event = 'form_submit';
        datalayerObject.form_id = formId;
        datalayerObject.form_name = formName;
        datalayerObject.form_destination = formDestination;
        datalayerObject.form_submit_text = formSubmitText;
        dataLayer.push(datalayerObject);
    }
};
